import {Component, EventEmitter, Inject, OnInit, ViewChild} from '@angular/core';
import {CommonModule} from "@angular/common";
import {MatListModule} from "@angular/material/list";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {FormsModule} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatOptionModule} from "@angular/material/core";
import {MatSelectModule} from "@angular/material/select";
import {AdaService} from "../../services/ada/ada.service";
import {AtecoService} from "../../services/ateco/ateco.service";
import {IscoService} from "../../services/isco/isco.service";
import {IstatService} from "../../services/istat/istat.service";
import {HttpService} from "../../services/http/http.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {concat, forkJoin} from "rxjs";
import {tap, toArray} from "rxjs/operators";
import {AssociazioniDialog} from "../associazioni-dialog/associazioni-dialog.component";
import {ClassificazioniDialog} from "../classificazioni-dialog/classificazioni-dialog.component";
import {MatTabsModule} from '@angular/material/tabs';
import searchboxdata from "../../../assets/searchboxdata.json";
import {DetailsDialog} from "../details-dialog/details-dialog.component";
import {MatPaginator, MatPaginatorModule} from "@angular/material/paginator";
import {MatTableDataSource, MatTableModule} from "@angular/material/table";
import {DetailCompetenzaDialog} from "../../pages/ricerca-profili-competenze/detail-competenze/detail-competenza.component";
import {MatCheckboxModule} from "@angular/material/checkbox";

@Component({
  selector: 'details-proposta-profilo-professionale-dialog',
  templateUrl: './details-proposta-profilo-professionale-dialog.component.html',
  styleUrls: ['./details-proposta-profilo-professionale-dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, MatListModule, MatTooltipModule, MatDialogModule, MatFormFieldModule, MatInputModule, FormsModule, MatButtonModule, MatIconModule, MatOptionModule, MatSelectModule, MatTabsModule, MatPaginatorModule, MatTableModule, MatCheckboxModule],
})
export class DetailsPropostaProfiloProfessionaleDialog implements OnInit {

  onAddClick = new EventEmitter();
  listaAda: any;
  listaAteco: any;
  listaIsco: any;
  listaIstat: any;
  listaCompetenze: any;
  listaAree: any;
  pdfVisible: boolean;
  xlsVisible: boolean;

  // Variabili per la gestione del dialog di creazione competenza
  sectionName: any;
  detailsData: any;

  // table
  displayedColumns: string[] = ['competenza', 'eqf', 'digitale', 'green', 'azioni'];
  dataSource = new MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  paginatorSize: any;


  constructor(
    public dialogRef: MatDialogRef<DetailsPropostaProfiloProfessionaleDialog>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private ada: AdaService,
    private ateco: AtecoService,
    private isco: IscoService,
    private istat: IstatService,
    private api: HttpService,
    private snackBar: MatSnackBar,
  ) {
  }

  ngOnInit(): void {
    this.pdfVisible = this.data.profilo.statoProposta.id === 5 || this.data.profilo.statoProposta.id === 7
      || this.data.profilo.statoProposta.id === 4;

    this.xlsVisible = this.data.profilo.statoProposta.id === 3 || this.data.profilo.statoProposta.id === 4
      || this.data.profilo.statoProposta.id === 5 || this.data.profilo.statoProposta.id === 7
      || this.data.profilo.statoProposta.id === 9 || this.data.profilo.statoProposta.id === 10
      || this.data.profilo.statoProposta.id === 11;

    this.loadData();
  }

  loadData() {
    this.api.getTAreaProfiloAttivo().subscribe({
      next: (response: any) => {
        this.listaAree = response.result;
      }
    })

    this.api.getCompetenzeByIdProposta(this.data.profilo.idProposta).subscribe({
      next: (response: any) => {
        this.listaCompetenze = response.result;
        this.paginatorSize = response.result.count;
        this.dataSource = new MatTableDataSource(this.listaCompetenze);
        this.dataSource.paginator = this.paginator;
      }
    });

    this.ada.getCodiciAdaByIdProposta(this.data.profilo.idProposta).subscribe({
      next: (response: any) => {
        this.listaAda = response.result;
      }
    });

    this.ateco.getCodiciAtecoByIdProposta(this.data.profilo.idProposta).subscribe({
      next: (response: any) => {
        this.listaAteco = response.result;
      }
    });

    this.isco.getCodiciIscoByIdProposta(this.data.profilo.idProposta).subscribe({
      next: (response: any) => {
        this.listaIsco = response.result;
      }
    });

    this.istat.getCodiciIstatByIdProposta(this.data.profilo.idProposta).subscribe({
      next: (response: any) => {
        this.listaIstat = response.result;
      }
    });
  }

  salva() {
    this.api.salvaModificaProfilo(this.data.profilo).subscribe({
      next: (response: any) => {
        this.snackBar.open('Profilo modificato con successo', 'close', {panelClass: 'successSnack'});
        this.dialogRef.close(response);
      }
    });
  }

  apriReferenziazioni() {
    this.openClassificazioniDialog(this.data);
  }

  apriCompetenze() {
    concat(
      this.api.getCompetenzeByIdProposta(this.data.profilo.idProposta),
      this.api.getRicercaCompetenzeDaAssociare({}, 0, 10)
    ).pipe(
      tap((response) => {
      }),
      toArray(),
      tap((response) => {
      })
    ).subscribe({
      next: (response: any) => {
        let competenzeProposta = response[0].result;
        let listaCompetenze = response[1].result.listaCompetenze
        // filtro per non far apparire nella lista competenze le competenze già associate
        let filteredLista = listaCompetenze.filter(function (o1: { id: any; }) {
          // filter out (!) items in result2
          return !competenzeProposta.some(function (o2: { id: any; }) {
            return o1.id === o2.id;          // assumes unique id
          });
        })

        this.openAssociaCompetenzeDialog('edit', competenzeProposta, filteredLista, this.data.profilo.idProposta, response[1].result.count, this.data.profilo.descrizioneArea.descrizione, this.data.profilo.nomeProfilo, 'competenze');
      }
    });
  }

  openDettaglioCompetenza(el: any) {

    const {
      listaAda,
      listaAteco,
      listaIsco,
      listaIstat,
      listaCompetenze,
      paginatorSize,
      paginator,
      displayedColumns,
      dataSource
    } = this;

    const dialogRef = this.dialog.open(DetailCompetenzaDialog, {

      data: {
        id: el.id,
        datiProfilo: this.data,
        classificazioniAda: listaAda,
        classificazioniIstat: listaIstat,
        classificazioniAteco: listaAteco,
        classificazioniIsco: listaIsco,
        competenze: listaCompetenze,
        paginatorSize,
        paginator,
        displayedColumns,
        dataSource
      },
      height: '95%',
      width: '100%',
      panelClass: 'detail-competenza-dialog'
    });


    dialogRef.afterClosed().subscribe((result: any) => {

    })
  }

  openClassificazioniDialog(data: any) {
    data['permission'] = true;
    data['element'] = data.profilo;
    const dialogRef = this.dialog.open(ClassificazioniDialog, {
      data: data,
      height: '115%',
      width: '100%'
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      this.loadData();
    });
  }

  openAssociaCompetenzeDialog(type: string, competenze: any, lista: any, idProposta: any, count: any, area: string, profilo: string, tipoAssociazione: string): void {

    const dialogRef = this.dialog.open(AssociazioniDialog, {
      data: {
        associate: competenze,
        lista: lista,
        area: area,
        count: count,
        profilo: profilo,
        permission: true,
        tipo: tipoAssociazione,
        isAssemblea: 'competenze'
      },
      height: '95%',
      width: '80%'
    });

    // Gestione salvataggio associazioni esistenti
    dialogRef.componentInstance.onSaveClick.subscribe((result: any) => {
      let data = result.associate;
      let tipo = tipoAssociazione;

      switch (tipo) {
        case 'competenze': {
          this.api.associaCompetenze(data, idProposta).subscribe({
            next: (response: any) => {
              const successMsg = response.messaggio && response.messaggio.length > 0
                ? response.messaggio[0]
                : 'Competenze associate con successo';
              this.snackBar.open(successMsg, 'close', {panelClass: 'successSnack'});
            },
            error: () => {
              this.snackBar.open('Errore di connessione con il server', 'close', {panelClass: 'errorSnack'});
            }
          });
          break;
        }

        case 'assemblea': {
          if (tipoAssociazione == 'competenze') {
            this.api.associaCompetenzeAssemblea(data, idProposta).subscribe({
              next: (response: any) => {
                this.snackBar.open('Competenze associate con successo', 'close', {panelClass: 'successSnack'});
              }
            })
          } else {
            this.api.associaProfiliAssemblea(data, idProposta).subscribe({
              next: (response: any) => {
                this.snackBar.open('Profili associati con successo', 'close', {panelClass: 'successSnack'});
              }
            })
          }
          break;
        }

        case 'conoscenze': {
          this.api.associaConoscenza(data, idProposta).subscribe({
            next: (response: any) => {
              this.snackBar.open('Conoscenze associate con successo', 'close', {panelClass: 'successSnack'});
            }
          })
          break;
        }

        case 'abilita': {
          this.api.associaAbilita(data, idProposta).subscribe({
            next: (response: any) => {
              this.snackBar.open('Abilità associate con successo', 'close', {panelClass: 'successSnack'});
            }
          })
          break;
        }
      }
    });

    /**
     * Gestione aggiunta nuova competenza.
     * Recupera le strutture dati necessarie (Tipologia, Aree, Categorie Base e Digitali)
     * prima di aprire il dialog di creazione.
     */
    dialogRef.componentInstance.onAddClick.subscribe((configs: any) => {
      if (configs.type === 'new' && configs.isProfilo) {
        const searchData = searchboxdata.list.find((el: any) => el.id === 2);
        configs.overrideSearchBoxData = searchData ? JSON.parse(JSON.stringify(searchData.data)) : [];
        this.sectionName = configs.sectionName;
        this.openNuovaCompetenzaDialog(configs);
      }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        // Logica post-chiusura se necessaria
      }
    });
  }

  /**
   * Apre il dialog DetailsDialog preconfigurato per la creazione di una nuova competenza.
   */
  openNuovaCompetenzaDialog(configs: any): void {
    this.detailsData = {
      "tipologia": {"id": null, "descrizione": "", "ordinamento": null},
      "tipoArea": {"id": null, "descrizione": "", "ordinamento": null},
      "descrizione": "",
      "informazioniCompetenza": "",
      "eqfCompetenza": null
    };

    const dialogRef = this.dialog.open(DetailsDialog, {
      data: {
        details: this.detailsData,
        permission: true,
        selectData: configs.overrideSearchBoxData,
        sectionName: 'gestioneCompetenze',
        type: 'new',
        isProfilo: true,
        loading: true
      },
      height: '95%',
      width: '100%'
    });

    forkJoin({
      tipologie: this.api.getTipologiaCompetenza(),
      aree: this.api.getTAreaProfiloAttivo(),
      catBase: this.api.getTipologiaCategoriaBase(),
      catDigitale: this.api.getTipologiaCategoriaDigitale()
    }).subscribe({
      next: (res: any) => {
        if (configs.overrideSearchBoxData[0]) {
          configs.overrideSearchBoxData[0].options = res.tipologie.result;
        }
        if (configs.overrideSearchBoxData[1]) {
          res.aree.result.sort((a: any, b: any) => (a.id < b.id ? -1 : 1));
          configs.overrideSearchBoxData[1].options = res.aree.result;
        }
        if (configs.overrideSearchBoxData[2]) {
          configs.overrideSearchBoxData[2].options = res.catBase.result;
        }
        if (configs.overrideSearchBoxData[4]) {
          configs.overrideSearchBoxData[4].options = res.catDigitale.result;
        }

        dialogRef.componentInstance.loading = false;
        dialogRef.componentInstance.selectData = configs.overrideSearchBoxData;
      },
      error: (err) => {
        dialogRef.componentInstance.loading = false;
        this.snackBar.open('Errore nel caricamento dei dati necessari', 'close', {panelClass: 'errorSnack'});
      }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result && result.details) {
        this.api.salvaCompetenza(result.details).subscribe({
          next: () => {
            this.snackBar.open('Competenza salvata con successo', 'close', {panelClass: 'successSnack'});
          },
          error: () => {
            this.snackBar.open('Errore durante il salvataggio della competenza', 'close', {panelClass: 'errorSnack'});
          }
        });
      }
    });
  }

  compareObjects(o1: any, o2: any): boolean {
    return o1 && o2 && o1.descrizione === o2.descrizione && o1.id === o2.id;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  reportProfiloProfessionalePdf() {
    this.api.reportProfiloProfessionalePdf(this.data.profilo.idProposta);
  }

  reportProfiloProfessionaleXls() {
    this.api.reportProfiloProfessionaleXls(this.data.profilo.idProposta);
  }
}
